import Section from "@/components/Section";
import { FONT_PRIMARY } from "@/theme/typography";
import { ROUTES } from "@/utils/navigation";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

const QuestionsSection = () => {
  const theme = useTheme();
  return (
    <Section pt={{ xs: 7.5, lg: 12.5 }} pb={{ xs: 7.5, lg: 12.5 }}>
      <Box
        sx={{
          backgroundColor: "#F9FAFC",
          padding: { xs: "24px", lg: "32px" },
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "16px",
        }}
      >
        <Box
          sx={{
            marginRight: { xs: "0px", lg: "20px" },
          }}
        >
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "1.5rem !important",
              textAlign: { xs: "center", lg: "start" },
              fontFamily: FONT_PRIMARY,
              marginBottom: "8px",
            }}
          >
            Need More? 
          </Typography>
          <Typography
            sx={{
              color: theme.palette.text.secondary,
              fontSize: { xs: "1rem", md: "1.125rem" },
              marginBottom: { xs: "32px", lg: "0px" },
            }}
          >
            Reach out to speak to a team member today. We’re always here to help!
          </Typography>
        </Box>
        <Button
          component={Link}
          to={ROUTES.contactUs}
          variant="contained"
          color="primary"
          disableElevation
          sx={{
            paddingY: "14px",
            paddingX: "65px",
            height: "50px",
            textWrap: "nowrap",
          }}
        >
          Get in touch
        </Button>
      </Box>
    </Section>
  );
};

export default QuestionsSection;
